export function hasProperty<K extends PropertyKey>(data: object, prop: K): data is Record<K, unknown> {
    return prop in data;
}
